/* Shared formatters and utils for the Intelligence page */

export const fmtNum = (n, opts = {}) => {
  if (n == null || n === "") return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return n;
  const { compact = false, decimals } = opts;
  if (compact && Math.abs(v) >= 1000) {
    if (Math.abs(v) >= 1e7) return (v / 1e7).toFixed(2) + " Cr";
    if (Math.abs(v) >= 1e5) return (v / 1e5).toFixed(2) + " L";
    if (Math.abs(v) >= 1e3) return (v / 1e3).toFixed(1) + "K";
  }
  return v.toLocaleString("en-IN", {
    maximumFractionDigits: decimals != null ? decimals : 2,
  });
};

export const fmtPct = (n, decimals = 2) => {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return `${(Number(n) * 100).toFixed(decimals)}%`;
};

export const fmtCurrency = (n, currency = "INR") => {
  if (n == null || n === "") return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return n;
  const symbol = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "د.إ" }[currency] || (currency + " ");
  return symbol + v.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

export const fmtDuration = (seconds) => {
  if (seconds == null || Number.isNaN(Number(seconds))) return "—";
  const s = Math.round(Number(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}m ${r}s`;
};

export const fmtDelta = (curr, prev) => {
  if (curr == null || prev == null || Number(prev) === 0) return null;
  const c = Number(curr), p = Number(prev);
  const pct = ((c - p) / p) * 100;
  return { pct, dir: pct >= 0 ? "up" : "down", abs: Math.abs(pct).toFixed(1) };
};

export const sourceBadge = (src) => {
  const colors = {
    shopify: { bg: "#96BF4815", color: "#A7F069", label: "Shopify" },
    meta: { bg: "#1877F215", color: "#5EA0F2", label: "Meta" },
    ga4: { bg: "#F9AB0015", color: "#FFC53D", label: "GA4" },
    blended: { bg: "#A78BFA15", color: "#C4B5FD", label: "Blended" },
  };
  if (!src) return null;
  const key = src.split(" ")[0]; // strip annotation like "blended (...)"
  return colors[key] || { bg: "#52525B22", color: "#A1A1AA", label: src };
};
